<section mat-dialog-content class="dialogContent">
  <!-- <div class="spinner">
    <mat-spinner [diameter]="24"></mat-spinner>
  </div> -->
  <div class="mensaje">
    {{Mensaje}}
  </div>
</section>
